import { useCallback, useContext } from 'react'
import ModalContext from 'contexts/ModalContext'
import { openSiteTakeoverCampaignModal } from '../components/siteTakeoverCampaignModalRegistry'

export function useOpenSiteTakeoverCampaignModal(): () => void {
  const showModal = useContext(ModalContext)

  return useCallback(() => {
    openSiteTakeoverCampaignModal(showModal)
  }, [showModal])
}
